import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import { Button, Card, Col, Container, Form, Row } from '@themesberg/react-bootstrap';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Routes } from '../../routes';
import { AlertMessage } from '../../components/PageHeader';

export default function Login() {
  const { login, tenantId: storedTenantId, clientSecret: storedSecret } = useAuth();
  const history = useHistory();
  const location = useLocation();
  const [tenantId, setTenantId] = useState(storedTenantId);
  const [clientSecret, setClientSecret] = useState(storedSecret);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const from = (location.state && location.state.from && location.state.from.pathname) || Routes.Dashboard.path;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(tenantId.trim(), clientSecret.trim());
      history.replace(from);
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main>
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col xs={12} md={8} lg={6}>
            <div className="d-flex align-items-center justify-content-between mb-4">
              <Link to={Routes.Welcome.path} className="d-flex align-items-center text-decoration-none">
                <FontAwesomeIcon icon={faShieldAlt} className="text-primary me-2" />
                <span className="fw-bold text-primary">Flowfence</span>
              </Link>
              <Link to={Routes.Welcome.path} className="text-gray small">
                <FontAwesomeIcon icon={faAngleLeft} className="me-1" />
                Back to homepage
              </Link>
            </div>
            <Card border="light" className="shadow-sm">
              <Card.Body className="p-4 p-lg-5">
                <h3 className="mb-2">Sign in</h3>
                <p className="text-gray mb-4">Exchange tenant credentials for a JWT access token.</p>
                <AlertMessage variant="danger" message={error} onClose={() => setError('')} />
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>Tenant ID</Form.Label>
                    <Form.Control
                      required
                      value={tenantId}
                      onChange={(e) => setTenantId(e.target.value)}
                      placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
                    />
                  </Form.Group>
                  <Form.Group className="mb-4">
                    <Form.Label>Client secret</Form.Label>
                    <Form.Control
                      required
                      type="password"
                      value={clientSecret}
                      onChange={(e) => setClientSecret(e.target.value)}
                      placeholder="Your client secret"
                    />
                  </Form.Group>
                  <Button variant="primary" type="submit" className="w-100" disabled={loading}>
                    {loading ? 'Signing in…' : 'Sign in'}
                  </Button>
                </Form>
                <div className="text-center mt-4">
                  <span className="text-gray">New tenant? </span>
                  <Card.Link as={Link} to={Routes.Register.path}>Register</Card.Link>
                </div>
                <div className="text-center mt-2">
                  <Card.Link as={Link} to={Routes.AdminLogin.path} className="text-gray small">
                    Platform admin
                  </Card.Link>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </main>
  );
}
